import { RootState } from "../store";
import { createSlice } from "@reduxjs/toolkit";

const initialState: {
  sessionId: string | null;
  selectedDeviceId: string | null;
  seamAccountId: string | null;
} = {
  sessionId: null,
  selectedDeviceId: null,
  seamAccountId: null,
};

const LockSlice = createSlice({
  name: "Locks",
  initialState,
  reducers: {
    setSelectedDeviceId: (state, action) => {
      state.selectedDeviceId = action.payload;
    },
    setSelectedSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setSeamAccountId: (state, action) => {
      state.seamAccountId = action.payload;
    },
  },
});

export const { setSelectedDeviceId, setSelectedSessionId, setSeamAccountId } = LockSlice.actions;

export default LockSlice.reducer;

export const getLockInfo = (state: RootState) => {
  return state.lockSlice;
};
